class FeaturedFlavor extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.fyf-product-slider');
    if (!swiperEl) return;

    // Initialize Swiper
    this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1.2,
        spaceBetween: 24,
        breakpoints: {
          540: { slidesPerView: 2 },
          768: { slidesPerView: 2.2 },
          992: { slidesPerView: 3, spaceBetween: 0 }
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        },
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev')
        }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

customElements.define('find-your-flavor', FeaturedFlavor);